export default {

    getReasonCodeDataInitialState: {
        loading: false,
        error: null,
        data: [],
        status: false,
        message: '',
    }
}